import { render, staticRenderFns } from "./ReprintModal.vue?vue&type=template&id=5923560f&scoped=true"
import script from "./ReprintModal.vue?vue&type=script&lang=js"
export * from "./ReprintModal.vue?vue&type=script&lang=js"
import style0 from "./ReprintModal.vue?vue&type=style&index=0&id=5923560f&prod&lang=scss&scoped=true"
import style1 from "./ReprintModal.vue?vue&type=style&index=1&id=5923560f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5923560f",
  null
  
)

export default component.exports